import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PasswordPage.css';

function PasswordPage({ setIsAuthenticated }) {
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            // 서버리스 함수(API)로 비밀번호를 전송하여 검증
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });

            const data = await response.json();

            if (data.success) {
                sessionStorage.setItem('isAuthorized', 'true');
                setIsAuthenticated(true);
                navigate('/');
            } else {
                alert(data.message);
            }
        } catch (error) {
            alert('인증 서버와 연결할 수 없습니다.');
        }
    };

    return (
        <div className="password-page-wrapper">
            <div className="password-card">
                <h1>법률사무소 온평</h1>
                <p>사이트 오픈 준비 중입니다.<br />관리자 비밀번호를 입력해주세요.</p>
                <form onSubmit={handleLogin}>
                    <input
                        type="password"
                        className="password-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="비밀번호 4자리"
                        maxLength="4"
                    />
                    <button type="submit" className="password-btn">입장하기</button>
                </form>
            </div>
        </div>
    );
}

export default PasswordPage;